import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

export default class ActivateCodeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.code = Stream('');
    this.loading = false;
    this.error = null;
    this.success = false;
    this.discussionId = vnode.attrs.discussionId || null;
    this.onSuccess = vnode.attrs.onSuccess || null;
  }

  className() {
    return 'ActivateCodeModal';
  }

  title() {
    return app.translator.trans('tf-cns-courses.forum.activate_code.title');
  }

  content() {
    if (this.success) {
      return (
        <div className="Modal-body">
          <div className="Alert Alert--success">
            {app.translator.trans('tf-cns-courses.forum.activate_code.success')}
          </div>
          <div className="Form-group">
            <Button
              className="Button Button--primary"
              onclick={() => this.hide()}
            >
              {app.translator.trans('tf-cns-courses.forum.activate_code.close')}
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="Modal-body">
        {this.error && (
          <div className="Alert Alert--error">{this.error}</div>
        )}

        <div className="Form-group">
          <label>{app.translator.trans('tf-cns-courses.forum.activate_code.label')}</label>
          <input
            className="FormControl"
            type="text"
            placeholder={app.translator.trans('tf-cns-courses.forum.activate_code.placeholder')}
            value={this.code()}
            oninput={(e) => {
              // 自动格式化：移除空格和连字符，然后每4位添加连字符
              let value = e.target.value.replace(/[\s-]/g, '').toUpperCase();
              if (value.length > 0) {
                value = value.match(/.{1,4}/g).join('-');
              }
              this.code(value);
              m.redraw();
            }}
            disabled={this.loading}
          />
          <small>{app.translator.trans('tf-cns-courses.forum.activate_code.hint')}</small>
        </div>

        <div className="Form-group">
          <Button
            className="Button Button--primary"
            type="submit"
            loading={this.loading}
            onclick={this.onsubmit.bind(this)}
          >
            {app.translator.trans('tf-cns-courses.forum.activate_code.submit')}
          </Button>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();
    
    if (!this.code()) {
      this.error = app.translator.trans('tf-cns-courses.forum.activate_code.error.empty');
      m.redraw();
      return;
    }

    this.loading = true;
    this.error = null;

    const data = {
      data: {
        type: 'group-activation-codes',
        attributes: {
          code: this.code(),
        },
      },
    };

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/cns-courses/activate-code',
      body: data,
    }).then((response) => {
      this.success = true;
      this.loading = false;
      m.redraw();

      const userId = app.session.user?.id?.();
      if (userId) {
        app.store.find('users', userId);
      }
      if (this.discussionId) {
        app.store.find('discussions', this.discussionId, {}).then(() => {
          m.redraw();
        });
      }
      // 课程列表兑换成功后调用 onSuccess，刷新访问权限使课程立即解锁
      if (typeof this.onSuccess === 'function') {
        this.onSuccess();
      }
      // 自动关闭弹窗，无需用户手动点击关闭
      setTimeout(() => this.hide(), 1000);
    }).catch((error) => {
      this.error = error.message || app.translator.trans('tf-cns-courses.forum.activate_code.error.failed');
      this.loading = false;
      m.redraw();
    });
  }
}

